import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "preview-menu",
      class: {
        "preview-menu--mobile": _setup.isMobile && _setup.isMobileInitial,
        "preview-menu--desktop-initial":
          _setup.isMobile && !_setup.isMobileInitial,
      },
      attrs: { "data-qa": "preview_menu" },
    },
    [
      _c(
        "div",
        {
          staticClass: "preview-menu__bar bg-gray-0",
          style: { height: _setup.previewMenuOffset },
        },
        [
          _setup.isMobileInitial
            ? _c(
                "div",
                { staticClass: "d-flex align-center justify-center py-2" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "text-none px-4",
                      attrs: {
                        "data-qa": "preview_menu_share",
                        text: "",
                        height: "40",
                      },
                      on: { click: _setup.handleShare },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "ui-icon-link-2 ui-icon-fz-big icon-secondary--text mr-3",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-body-2 text--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.tStatic("Поделиться ссылкой")) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "d-flex align-center py-4",
                  class: _setup.context.request.feature_flags
                    .ff_lpu_branding_page_v4
                    ? "container"
                    : "b-container",
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center flex-grow-1 w-0" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "text-none px-4",
                          attrs: {
                            "data-qa": "preview_menu_edit",
                            text: "",
                            height: "40",
                            href: _setup.editUrl,
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "ui-icon-create ui-icon-fz-big icon-secondary--text mr-3",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-body-2 text--text" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _setup.tStatic("Режим редактирования")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center gc-1 flex-shrink-0",
                      attrs: { "data-qa": "preview_menu_devices" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          class: !_setup.isMobile
                            ? "primary--text"
                            : "icon-secondary--text",
                          attrs: {
                            "data-qa": "preview_menu_desktop",
                            icon: "",
                            height: "40",
                            width: "40",
                            "aria-pressed": !_setup.isMobile,
                            "aria-label": _setup.tStatic("Настольная версия"),
                          },
                          on: {
                            click: function ($event) {
                              return _setup.changeFlavour("full")
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "ui-icon-monitor ui-icon-fz-big",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          class: _setup.isMobile
                            ? "primary--text"
                            : "icon-secondary--text",
                          attrs: {
                            "data-qa": "preview_menu_mobile",
                            icon: "",
                            height: "40",
                            width: "40",
                            "aria-pressed": _setup.isMobile,
                            "aria-label": _setup.tStatic("Мобильная версия"),
                          },
                          on: {
                            click: function ($event) {
                              return _setup.changeFlavour("mobile")
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "ui-icon-phone-check ui-icon-fz-big",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center justify-end flex-grow-1 gc-2 w-0",
                    },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "text-none px-4",
                          attrs: {
                            "data-qa": "preview_menu_share",
                            height: "40",
                            text: "",
                          },
                          on: { click: _setup.handleShare },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "ui-icon-link-2 ui-icon-fz-big icon-secondary--text mr-3",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-body-2 text--text" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_setup.tStatic("Поделиться ссылкой")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          staticClass: "text-none px-4",
                          attrs: {
                            "data-qa": "preview_menu_moderation",
                            color: "primary",
                            height: "40",
                            href: _setup.moderationUrl,
                            depressed: "",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.tStatic("Модерация")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }